var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystation2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v.423h10.424V2.77H0V6h.423V3.192h10.386V0H0z",
    fill: "url(#playstation_2_svg__paint0_linear_920_480)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.925 0v.423h10.424V2.77H23.925V6h10.847v-.423H24.387V3.192h10.385V0H23.925z",
    fill: "url(#playstation_2_svg__paint1_linear_920_480)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.347 0v5.577H10.81V6h6V.423h5.5V0h-5.962z",
    fill: "url(#playstation_2_svg__paint2_linear_920_480)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "playstation_2_svg__paint0_linear_920_480",
    x1: 5.404,
    y1: 6,
    x2: 5.404,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#24B0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2785C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#2965AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2B529B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B4B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "playstation_2_svg__paint1_linear_920_480",
    x1: 29.349,
    y1: 5.797,
    x2: 29.349,
    y2: 0.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "playstation_2_svg__paint2_linear_920_480",
    x1: 16.559,
    y1: 6,
    x2: 16.559,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#178FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2273AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2A5EA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2E5299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304E97"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgPlaystation2 as ReactComponent };